import { useState, useCallback } from 'react';
import { type OptimizeAnalysisResult } from '@/lib/api/image-optimize';

export interface EditHistoryEntry { timestamp: Date; action: string; labelKey: string; imageUrl: string; s3Key: string }

export interface ImageOptimizeState {
  currentFile: File | null;
  currentImageUrl: string | null;
  editedImageUrl: string | null;
  editedS3Key: string | null;
  analysisResult: OptimizeAnalysisResult | null;
  isAnalyzing: boolean;
  isEditing: boolean;
  openGroup: string | null;
  selectedAction: string | null;
  editHistory: EditHistoryEntry[];
}

export function useImageOptimizeState() {
  const [state, setState] = useState<ImageOptimizeState>({
    currentFile: null,
    currentImageUrl: null,
    editedImageUrl: null,
    editedS3Key: null,
    analysisResult: null,
    isAnalyzing: false,
    isEditing: false,
    openGroup: 'analyse',
    selectedAction: null,
    editHistory: [],
  });

  const setFile = useCallback((file: File | null) => {
    if (state.currentImageUrl) URL.revokeObjectURL(state.currentImageUrl);
    if (state.editedImageUrl) URL.revokeObjectURL(state.editedImageUrl);
    setState(prev => ({
      ...prev,
      currentFile: file,
      currentImageUrl: file ? URL.createObjectURL(file) : null,
      editedImageUrl: null,
      analysisResult: null,
      editHistory: [],
      selectedAction: null,
    }));
  }, [state.currentImageUrl, state.editedImageUrl]);

  const reset = useCallback(() => setFile(null), [setFile]);

  return { state, setState, setFile, reset };
}